import Mechanical1 from '../assets/mechanical.jpeg';
import Mechanical2 from '../assets/trucks.jpeg';
import Mechanical3 from '../assets/work.jpeg';
import Mechanical4 from '../assets/MechanicalS.jpg';
import Mechanical5 from '../assets/MechanicalS2.jpg';
export const PictureList =[
    {
        id :1,
        type:"Electrical",
        picture : "https://cdn.pixabay.com/photo/2022/01/18/08/15/man-working-6946569_960_720.jpg",
    },
    {
        id :2,
        type:"Electrical",
        picture : "https://cdn.pixabay.com/photo/2022/01/18/08/15/electricity-6946568_960_720.jpg",
    },
    {
        id:3,
        type:"Electrical",
        picture : "https://cdn.pixabay.com/photo/2022/01/18/08/15/electricity-6946567_960_720.jpg",
    },
    {
        id:4,
        type:"Electrical",
        picture : "https://cdn.pixabay.com/photo/2022/01/18/08/15/engineering-6946564_960_720.jpg",
    },
    {
        id:5,
        type:"Electrical",
        picture : "https://cdn.pixabay.com/photo/2022/01/18/08/15/technology-6946560_960_720.jpg",
    },

    // Pictures of mechanical Engineering
    {
        id:6,
        type:"Mechanical",
        picture : Mechanical1,
    },
    {
        id:7,
        type:"Mechanical",
        picture : Mechanical5,
    },
    {
        id:8,
        type:"Mechanical",
        picture : Mechanical2,
    },
    {
        id:9,
        type:"Mechanical",
        picture : Mechanical3,
    },
    
    {
        id:10,
        type:"Mechanical",
        picture : Mechanical4,
    }
]